// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"2c580b24","513":"166f8e79","703":"645dee32"}[chunkId] + ".chunk.js";
};